import { Account, AccountRequest } from "../domain/account.interface";
import { instanceBo } from "../utils/axios.create";

export const accountService = {
	async createAccount(accountData: AccountRequest): Promise<Account> {
		const response = await instanceBo.post("/accounts", accountData);
		return response.data.body.account;
	},

	async getAccounts(): Promise<Account[]> {
		const response = await instanceBo.get("/accounts");
		// Backend returns accounts directly in body array, not body.accounts
		return Array.isArray(response.data.body)
			? response.data.body
			: response.data.body.accounts || [];
	},

	async getAccount(accountId: string): Promise<Account> {
		// Note: This endpoint might need to be implemented in the backend
		const response = await instanceBo.get(`/accounts/${accountId}`);
		return response.data.body.account;
	},

	async updateAccount(
		accountId: string,
		accountData: Partial<AccountRequest>,
	): Promise<Account> {
		// The backend `BaseService.update` does a wholesale replace of any
		// sub-document it receives (Mongoose default), so the caller must
		// always send the full `auth0` / `qlik` / `tremendous` objects with
		// every existing field intact. The Accounts edit dialog merges the
		// current values with the user's edits before calling this.
		const response = await instanceBo.put(
			`/accounts/${accountId}`,
			accountData,
		);
		return response.data.body.account ?? response.data.body;
	},
};
